import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BOOK } from '../content/book';

/**
 * The launch band above the header: one line introducing the book, with a
 * link to it. A reader can close it; the choice is remembered on that
 * device. Not shown on the book page itself. Remove after the launch window.
 */
const KEY = 'rbl-book-band-closed';

const BookBand = () => {
  const { pathname } = useLocation();
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    try { setClosed(window.sessionStorage.getItem(KEY) === '1'); } catch (e) { /* ignore */ }
  }, []);

  if (closed || pathname === '/book') return null;

  const close = () => {
    setClosed(true);
    try { window.sessionStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
  };

  return (
    <div className="bg-navy-900 text-white dark:border-b dark:border-navy-700">
      <div className="mx-auto max-w-page px-5 md:px-8 min-h-[44px] flex items-center justify-between gap-4">
        <p className="font-sans text-small py-2">
          <span className="font-semibold">{BOOK.title}</span>, the book, is out now in hardcover, paperback, and Kindle.{' '}
          <Link to="/book" className="font-medium text-emerald-300 hover:text-white whitespace-nowrap">About the book</Link>
        </p>
        <button type="button" onClick={close} aria-label="Close" className="shrink-0 inline-flex items-center justify-center h-9 w-9 rounded-sm text-navy-400 hover:text-white">
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75} aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>
      </div>
    </div>
  );
};

export default BookBand;
